export default __webpack_public_path__ + "static/debt-consolidation-hero-image-2c0f338cee417b11e8d1b98f10e5c4d7.webp";